import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import socialImage from "../images/fumc-social-logo.jpg"
import favicon16x16 from "../images/fumc-icon16x16.png"
import favicon32x32 from "../images/fumc-icon32x32.png"
import favicon64x64 from "../images/fumc-icon64x64.png"

function Seo({ description, lang, meta, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title
  const image = `${site.siteMetadata.siteUrl}${socialImage}`

  return (
    <>
      <html lang="en" />
      <title>{defaultTitle ? `${title} | ${defaultTitle}` : null}</title>
      <link rel="icon" type="image/png" sizes="16x16" href={favicon16x16}></link>
      <link rel="icon" type="image/png" sizes="32x32" href={favicon32x32}></link>
      <link rel="shortcut icon" type="image/png" href={favicon64x64}></link>
      <meta name="description" content={metaDescription}></meta>
      <meta property="og:title" content={title}></meta>
      <meta property="og:description" content={metaDescription}></meta>
      <meta property="og:type" content="website"></meta>
      <meta property="twitter:card" content="summary"></meta>
      <meta
        property="twitter:creator"
        content={site.siteMetadata.author}
      ></meta>
      <meta property="twitter:title" content={title}></meta>
      <meta property="twitter:description" content={metaDescription}></meta>
      <meta property="og:image" content={image}></meta>
      <meta property="og:image:width" content="1208px"></meta>
      <meta property="og:image:height" content="638px"></meta>
      <meta name="twitter:card" content="summary_large_imag"></meta>
    </>
  )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string.isRequired,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default Seo
